import { RouteConfig } from "vue-router";
import { RTeammatesBrowse } from "@/pages/Layout/views/Employer/views/Teammates/Browse/RTeammatesBrowse";
import { RRemoveTeammate } from "@/pages/Layout/views/Employer/views/Teammates/RemoveTeammate/RRemoveTeammate";

export const REmployerTeammates: RouteConfig = {
  path: "teammates",
  component: () =>
    import(
      /* webpackChunkName: "employer-teammates" */
      "./VEmployerTeammates.vue"
    ),
  meta: {
    title: "Teammates",
    icon: "settings-outline",
    hide: true,
  },
  children: [RTeammatesBrowse, RRemoveTeammate],
};
